<template>
    <billing-layout>
         <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-chart-line"></i> Customer</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-center justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                               <li class="breadcrumb-item">
                                   <router-link :to="{ name : 'BillingReport'}" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
              <div class="col-6">
                <div class="card card-body">
                  <div class="bgloading" v-if="isLoading">
                    <Loader></Loader>
                  </div>
            <div class="card-body contenedor-total" ><div role="alert" class="alert alert-success alert_totales" style="
    margin-right: 10px; width: 48%;">
                Customer Actives: <h1><span class="badge badge-success">{{Totalactivos.length}}</span></h1></div><div role="alert" class="alert alert-danger alert_totales" style="
    margin-left: 10px; width: 48%;">
                Customer Inactives: <h1 ><span class="badge badge-danger">{{inactivos.length}}</span></h1></div>
            </div>
            <div style="width:250px; margin:0 auto; text-align:center;">
              <button type="button" class="btn btn-info"  style="margin-right:10px;" @click="ExportCustomer()"><i class="fas fa-arrow-alt-circle-down"></i> Export Customers</button>
            </div>

<!-- <button type="file" class="btn btn-success" @change="loadCSV($event)"><i class="fas fa-upload"></i> Upload Customers</button> -->



                </div>
              </div>

              <div class="col-6">
                <div class="card card-body">
                   <div class="bgloading" v-if="Loading">
                    <Loader></Loader>
                  </div>
                      <div style="display:flex;">
                          <div style="width:250px; margin:0 auto; text-align:center;">
                            <span>Document format Template <b>.xlsx</b></span>
                            <button type="button" class="btn btn-secondary" style="margin-right:10px;" @click="MDownloadTemplate()"><i class="fas fa-download"></i> Download</button>
                         </div>
                          <div style="width:250px; margin:0 auto; text-align:center;">
                            <span>Document format Template <b>.csv</b></span>
                            <button type="button" class="btn btn-secondary" style="margin-right:10px;" @click="MDownloadTemplateCSV()"><i class="fas fa-download"></i> Download</button>
                         </div>
                      </div>
           <hr>
     <div style="position:relative;display:flex;align-items: center;justify-content: space-between; background-color: #ececec;padding: 10px;">
         <Loader v-if="Loading1"></Loader>
         <div>
            <h4 style="padding-bottom:8px; margin-top:20px;text-align: left;">Upload Customers <b>XLSX</b></h4>
            <div class="" style="margin-top:0px;width:330px; margin-bottom:20px;">
                <input type="file" id="file" ref="file" class="form-control-file" @change="onChangeFileUpload"/>
            <!-- <input type="file" class="custom-file-input" id="customFileLang"  @change="loadCSV($event)" lang="es"> -->
            
            </div>
        </div>
        <button v-on:click="submitForm()" class="btn btn-success"><i class="fas fa-upload"></i> Start</button>
     </div>
     <div style="position:relative;margin-top: 20px;display:flex;align-items: center;justify-content: space-between; background-color: #ececec;padding: 10px;">
         <Loader v-if="Loading2"></Loader>
         <div>
            <h4 style="padding-bottom:8px; margin-top:20px;text-align: left;">Upload Customers <b>CSV</b></h4>
            <div class="" style="margin-top:0px;width:330px; margin-bottom:20px;">
                <input type="file" id="file" ref="file" class="form-control-file" @change="onChangeFileUpload2"/>
            <!-- <input type="file" class="custom-file-input" id="customFileLang"  @change="loadCSV($event)" lang="es"> -->
           
            </div>
        </div>
        <button v-on:click="submitFormCSV()" class="btn btn-success"><i class="fas fa-upload"></i> Start</button>
     </div>
                </div>
              </div>

            </div>
        </div>

    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
export default {
     name:'Report',
    components:{
            Loader,
            BillingLayout
    },
    data() {
        return{
            Loading : false,
            isLoading : false,
            Loading1 : false,
            Loading2 : false,
            attachment : { name : null,file: null },
            customers : []
        } 
    },
    created(){
    this.CustomerList();
    },
  
    methods:{
        submitForm(){
          this.Loading1 = true;
            let formData = new FormData();
            formData.append('name', this.attachment.name);
            formData.append('file', this.attachment.file);
            window.billing.post('import/customers/' + window.localuserdata,formData)
                .then((response) => {
                  this.Loading1 = false;
                  if(response.data.status){
                    this.$swal.fire({
                        type: 'success',
                        title: 'Imported',
                        text: 'Successful import to verify enter the customers',
                        showConfirmButton: false,
                        timer: 7000
                    });
                    this.CustomerList();
                  }
                }).catch((error) => {
                    this.Loading2 = false
                    console.log(error);
        
                });
      },
      submitFormCSV(){
          this.Loading2 = true;
            let formData = new FormData();
            formData.append('name', this.attachment.name);
            formData.append('file', this.attachment.file);
            window.billing.post('import/customerscsv/' + window.localuserdata,formData)
                .then((response) => {
                  this.Loading2 = false;
                  if(response.data.status){
                    this.$swal.fire({
                        type: 'success',
                        title: 'Imported',
                        text: 'Successful import to verify enter the customers',
                        showConfirmButton: false,
                        timer: 7000
                    });
                    this.CustomerList();
                  }
                }).catch((error) => {
                  this.Loading2 = false;
                  console.log(error);
              });
      },
      onChangeFileUpload(event){
          this.attachment.file = event.target.files[0]
      },
     onChangeFileUpload2(event){
          this.attachment.file = event.target.files[0]
      },
       ExportCustomer(){
           this.isLoading = true
           console.log('export');
        window.billing.get('report/export/customers/' + window.localuserdata)
                .then((response) => {
                    this.isLoading = false
					 console.log(response.data.result)
                    window.open(window.urlbase+'files/'+response.data.result , "_blank");
                }).catch((error) => {
                    console.log(error);
                    this.isLoading = false
                });
       },
       CustomerList(){
        this.isLoading = true
        window.billing.get('report/customers/' + window.localuserdata)
                .then((response) => {
                    this.isLoading = false
					           console.log(response.data)
                   if(response.data.status){
                     this.customers = response.data.result
                   }
                }).catch((error) => {
                    console.log(error);
                    this.isLoading = false
                });
       },
       MDownloadTemplate(){
           window.open(window.urlbase+'files/customers-format.xlsx' , "_blank");
       },
       MDownloadTemplateCSV(){
           window.open(window.urlbase+'files/customers-format.csv' , "_blank");
       },
  
    },
    watch:{
        
    },
    computed:{
      Totalactivos:  function () {
            return this.customers.filter(r => r.active === 1 && r.activorestore === 0);
        },
      inactivos:  function () {
            return this.customers.filter(r => r.active === 0);
        },
    }
};
</script>
<style scope="sass">
i.fas.fa-arrow-left {
    font-size: 13px;
}
</style>
